export default __webpack_public_path__ + "static/media/icon-close.e7218df2.svg";